import React from 'react';

function Footer() {
  return (
    <footer className="bg-[#1F0A0F] text-cream-50">
      <div className="relative overflow-hidden">
        {/* Texture overlay */}
        <div className="absolute inset-0 bg-texture-light opacity-[0.02]"></div>
        
        <div className="relative max-w-7xl mx-auto px-6 lg:px-8 py-12 md:py-16">
          {/* Top decorative border */}
          <div className="absolute top-0 left-4 right-4">
            <div className="h-px bg-gradient-to-r from-transparent via-gold-400/30 to-transparent"></div>
          </div>
          
          <div className="py-12">
            <div className="text-center space-y-16">
              {/* Main quote section */}
              <div className="space-y-8">
                <div className="inline-flex flex-col items-center">
                  {/* Quote */}
                  <blockquote className="max-w-2xl relative px-8">
                    <div className="absolute -top-6 -left-2 text-4xl text-gold-400/30 font-serif">"</div>
                    <p className="font-display text-3xl md:text-4xl text-cream-200/90 italic tracking-wide leading-relaxed">
                      To live in hearts we leave behind is not to die.
                    </p>
                    <div className="absolute -bottom-6 -right-2 text-4xl text-gold-400/30 font-serif transform rotate-180">"</div>
                  </blockquote>
                  
                  {/* Attribution with ornate divider */}
                  <div className="mt-12 flex flex-col items-center">
                    <div className="flex items-center justify-center gap-4 mb-4">
                      <div className="w-12 h-px bg-gold-400/30"></div>
                      <div className="text-gold-400/80 text-lg">✤</div>
                      <div className="w-12 h-px bg-gold-400/30"></div>
                    </div>
                    <cite className="font-serif text-sm text-cream-300/60 tracking-widest not-italic">
                      THOMAS CAMPBELL
                    </cite>
                  </div>
                </div>
              </div>

              {/* Mission statement with ornate frame */}
              <div className="max-w-2xl mx-auto relative px-8 py-6">
                <div className="absolute top-0 left-0 w-16 h-16 border-t-2 border-l-2 border-gold-400/20"></div>
                <div className="absolute top-0 right-0 w-16 h-16 border-t-2 border-r-2 border-gold-400/20"></div>
                <div className="absolute bottom-0 left-0 w-16 h-16 border-b-2 border-l-2 border-gold-400/20"></div>
                <div className="absolute bottom-0 right-0 w-16 h-16 border-b-2 border-r-2 border-gold-400/20"></div>
                
                <p className="font-serif text-base text-cream-300/80 leading-relaxed">
                  This digital memorial is dedicated to preserving and honoring cherished memories,
                  ensuring that stories of love and legacy endure through time.
                </p>
              </div>

              {/* Footer content */}
              <div className="pt-16 border-t border-cream-100/10">
                <div className="flex flex-col items-center space-y-8">
                  {/* Logo or brand name */}
                  <div className="font-ornate text-2xl text-cream-200/90">
                    Digital Memorials
                  </div>
                  
                  {/* Navigation links */}
                  <nav className="flex flex-wrap justify-center gap-x-8 gap-y-4">
                    <a 
                      href="/privacy-policy.pdf"
                      target="_blank" 
                      rel="noopener noreferrer" 
                      className="font-serif text-sm text-cream-300/60 hover:text-cream-200 transition-colors duration-300"
                    >
                      Cookies & Privacy Policy
                    </a>
                    <a 
                      href="/terms-of-use.pdf"
                      target="_blank" 
                      rel="noopener noreferrer" 
                      className="font-serif text-sm text-cream-300/60 hover:text-cream-200 transition-colors duration-300"
                    >
                      Terms of Use
                    </a>
                    <a 
                      href="https://digitalmemorials.ie/contact" 
                      target="_blank" 
                      rel="noopener noreferrer" 
                      className="font-serif text-sm text-cream-300/60 hover:text-cream-200 transition-colors duration-300"
                    >
                      Contact
                    </a>
                  </nav>
                  
                  {/* Copyright */}
                  <p className="font-serif text-sm text-cream-300/40">
                    © {new Date().getFullYear()} Digital Memorials. All rights reserved.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Bottom decorative border */}
          <div className="absolute bottom-0 left-4 right-4">
            <div className="h-px bg-gradient-to-r from-transparent via-gold-400/30 to-transparent"></div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer; 